'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'bug';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f188';
var svgPathData = 'M288 32c35.3 0 64 28.7 64 64L224 96c0-35.3 28.7-64 64-64zM192 96l0 3.6c0 15.7 12.7 28.4 28.4 28.4l135.1 0c15.7 0 28.4-12.7 28.4-28.4l0-3.6c0-53-43-96-96-96s-96 43-96 96zM416 280l0 72c0 65.3-48.9 119.1-112 127l0-207c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 207c-63.1-7.9-112-61.7-112-127l0-72c0-39.8 32.2-72 72-72l112 0c39.8 0 72 32.2 72 72zM153.8 211.4c-14.4 16.4-23.8 37.5-25.5 60.6L16 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0 0 48c0 10.2 1 20.2 2.8 29.9L38.4 451.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l83.1-62.3C165 471.8 221.8 512 288 512s123-40.2 147.3-97.5l83.1 62.3c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4l-92.4-69.3c1.8-9.7 2.8-19.7 2.8-29.9l0-48 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112.3 0c-1.8-23.1-11.1-44.2-25.5-60.6 31.7-23.7 77-57.7 115.4-86.6 7.1-5.3 8.5-15.3 3.2-22.4s-15.3-8.5-22.4-3.2c-204.7 153.6-87.8 65.8-121.6 91.2-15.5-9.1-33.5-14.4-52.8-14.4l-112 0c-19.3 0-37.3 5.2-52.8 14.4l-1.6-1.2-120-90c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4l115.4 86.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBug = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;